import { trackWorkEvent, WorkLaunchEventName } from '@/models/analytics/features/work';
import { isProductFeedbackAvailable } from '@/utils/heidiReach';
import {
  ProjectMessageActions as ProjectMessageActionsView,
  type ProjectMessageActionsProps,
} from '@heidi/agents';
import type { TrackWorkMessageActioned } from '@heidi/agents/contracts';

const trackMessageActioned: TrackWorkMessageActioned = (props) =>
  trackWorkEvent(WorkLaunchEventName.WorkMessageActioned, props);

/**
 * Binds a Work reply's action row to the app's Work analytics emit, and hides
 * the thumbs wherever this build offers no product feedback.
 */
export const ProjectMessageActions = ({
  hideFeedback = false,
  ...props
}: ProjectMessageActionsProps) => (
  <ProjectMessageActionsView
    {...props}
    hideFeedback={hideFeedback || !isProductFeedbackAvailable}
    trackMessageActioned={trackMessageActioned}
  />
);
